import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { SEO } from "../components/SEO";
import { REVIEWS } from "../data/reviews";

export default function AffiliateDisclosure() {
  return (
    <>
      <SEO title="Affiliate Disclosure" description="FTC-compliant affiliate disclosure for aiwritingplatforms.com, including which tools we've tested and when." />
      <section className="pt-36 pb-24 px-6 lg:px-10">
        <div className="max-w-3xl mx-auto">
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="font-mono-tag text-xs uppercase tracking-[0.2em] text-gold mb-4">Legal</motion.p>
          <motion.h1 initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="font-display font-black text-4xl text-white tracking-tight">Affiliate Disclosure</motion.h1>

          <div className="mt-10 space-y-8 text-zinc-300 leading-relaxed">
            <p>In accordance with FTC guidelines on affiliate marketing, we want to be fully transparent: aiwritingplatforms.com participates in affiliate programs for the AI writing tools we review, including Phrasly.ai, Rytr, and Codex Leo AI, as well as WhatConverts and Dry Ground AI, referenced in some of our guides.</p>
            <p>If you click a link on this site and sign up for or purchase one of these tools, we may earn a commission — typically a recurring percentage of your subscription or a one-time referral fee — at absolutely no additional cost to you. This is one of the ways we fund the time it takes to test each tool for 12-21 days before publishing a review.</p>
            <div>
              <h2 className="font-display font-bold text-xl text-white mb-3">Our Editorial Independence</h2>
              <p>Affiliate relationships never influence our testing scores or rankings. We purchase every subscription ourselves, and a tool's affiliate commission rate has no bearing on its rating. We publish honest limitations for every tool, including the ones we're affiliated with.</p>
            </div>
            <div>
              <h2 className="font-display font-bold text-xl text-white mb-3">Tools We've Tested (With Dates)</h2>
              <ul className="space-y-2 mt-3">
                {REVIEWS.map((r) => (
                  <li key={r.slug} className="flex justify-between border-b border-white/10 pb-2">
                    <Link to={`/reviews/${r.slug}`} className="text-primary hover:text-[#5C7CFA]">{r.title.split(":")[0]}</Link>
                    <span className="text-zinc-500 text-sm">Last tested: {r.lastTested}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h2 className="font-display font-bold text-xl text-white mb-3">Questions?</h2>
              <p>If you have any questions about our affiliate relationships or testing process, see our <Link to="/about" className="text-primary hover:text-[#5C7CFA]">About page</Link> for our full methodology.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
